import {Component, Input} from '@angular/core';
import {PolicyPg} from '../../../../models/policy.model';

@Component({
    selector: 'app-cpi-policy-modal',
    templateUrl: './policy-pg-download-modal.component.html',
})
export class PolicyPgDownloadModalComponent {

    @Input() policy: PolicyPg;
}
